import { useSlotsTrackerMetricsApi } from '@pages/demos'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useSlotsTrackerMetricsApi()
})
